// extracted by mini-css-extract-plugin
export default {"snakeGrid":"Snake_snakeGrid__wNfai"};